import React from 'react';
import { useNavigate } from 'react-router-dom';


const Home = () => {
  const navigate = useNavigate();

  const handleSearchIT = () => {
    navigate('/search-categories');
  };

  const handleCurbIT = () => {
    navigate('/curb-it');
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-2xl text-purple font-orbit mb-20 overflow-hidden">
        <span className="inline-block animate-drop">Welcome {localStorage.getItem('user')}!</span>
      </h1>

      <div className="flex flex-col items-center space-y-4 sm:flex-row sm:space-x-4">
        <button
          className="bg-teal-500 text-slate-200 rounded-full h-40 w-40 text-2xl xl:h-60 
          xl:w-60 hover:animate-bounce"
          onClick={handleSearchIT}
        >
          SearchIT!
        </button>
        <button
          className="bg-bubble-gum text-slate-200 rounded-full h-40 w-40 text-2xl xl:h-60 xl:w-60 hover:animate-bounce"
          onClick={handleCurbIT}
        >
          CurbIT!
        </button>
      </div>
    </div>
  );
};

export default Home;
